// TODO: This needs to tie to the BE somehow. Fixme please!
export const SHOP_CURRENCY = "usd";
